import { useChrome } from "@/context/ChromeContext";
import { mobileScreen } from "./MobileList";

/**
 * A named stand-in for the views that only work at a desk.
 *
 * Rendering the desktop component here instead would produce a sideways-
 * scrolling Gantt chart or a six-column grid — technically present, useless in
 * practice, and worse than an honest sentence. These routes still exist because
 * a bookmark or an old link can land on them.
 */
export function NotOnPhone({ name, detail }: { name: string; detail?: string }) {
  useChrome({ title: name, subtitle: "Desktop only" }, [name]);
  return (
    <div style={{ ...mobileScreen, textAlign: "center", paddingTop: 64 }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink)" }}>{name} needs a bigger screen</div>
      <div style={{ fontSize: 13, color: "var(--muted)", marginTop: 6, lineHeight: 1.5 }}>
        {detail ?? "It's built around a wide layout that doesn't survive a phone. Open Project Hub on a laptop to use it."}
      </div>
    </div>
  );
}
